import { Link } from "react-router-dom"
import React from "react"

export default function LinkCard(props) {
  return (
    <Link to={`${props.link}`}>
      <div className="link-card">
        <div className="link-card-icon">{props.icon}</div>
        <div className="link-card-title">
          <h3>{props.title}</h3>
        </div>
        <div className="link-card-arrow">
          <ion-icon name="chevron-forward"></ion-icon>
        </div>
      </div>
    </Link>
  )
}
